import {useDispatch} from "react-redux";

import {AppDispatch} from "../types/AppDispatch";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
import {useDispatch} from "react-redux";

import {AppDispatch} from "../types/AppDispatch";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
